// extracted by mini-css-extract-plugin
export default {"Container":"NotificationsList_Container__qfjsR"};